import React from "react";

export default function Privacy() {
  return (
    <article className="max-w-3xl mx-auto px-6 lg:px-10 py-16 prose prose-neutral">
      <div className="label-eyebrow mb-3">Legal</div>
      <h1 className="font-display text-5xl tracking-tight mb-8">Privacy Policy</h1>
      <p className="text-[hsl(var(--muted-foreground))] leading-relaxed">Last updated: {new Date().toLocaleDateString()}</p>

      <h2 className="font-display text-2xl mt-10 mb-3">What we collect</h2>
      <p>We collect the minimum needed to run Humanly: your email, name, hashed password, subscription status, and the text you humanize. We never sell or share this with third parties.</p>

      <h2 className="font-display text-2xl mt-10 mb-3">How we use your text</h2>
      <p>Text you humanize is sent to our AI provider to generate the rewrite and stored against your account so you can access it in History. We do not use your text to train models.</p>

      <h2 className="font-display text-2xl mt-10 mb-3">Payments</h2>
      <p>Payments are processed by Stripe. We never store card details on our servers.</p>

      <h2 className="font-display text-2xl mt-10 mb-3">Deleting your data</h2>
      <p>You can delete individual rewrites and style profiles at any time. Contact us to fully delete your account and associated data.</p>

      <h2 className="font-display text-2xl mt-10 mb-3">Contact</h2>
      <p>Questions about privacy: hello@humanly.app</p>
    </article>
  );
}
